import React from "react";
import {Helmet} from "react-helmet";
import Nav from "./nav";
import Header from "./header";
import { motion } from "framer-motion";
import "./style.scss";

const Layout = ({ children, title }) => {
  const layout = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  if (title == null) {
    title = "RSC Chaînes"
  }

  return (
    <motion.div initial="hidden" animate="visible" variants={layout}>
      <Helmet
        title={title}
      />
      <Nav />
      <div>
        <Header title={title} />
        {children}
      </div>
    </motion.div>
  );
};

export default Layout;
